// Changelog entries - add new entries at the top
export interface ChangelogEntry {
  version: string;
  date: string;
  title: string;
  highlights: string[];
  type: 'major' | 'minor' | 'patch';
  isNew?: boolean; // Flag for announcement banner
}

export const CHANGELOG: ChangelogEntry[] = [
  {
    version: "1.0.1",
    date: "2024-12-06",
    title: "Performance & Roadmap Update",
    highlights: [
      "New public roadmap page - see what's coming next!",
      "Aggressive cache-busting for instant updates",
      "Enhanced What's New popup with roadmap links",
      "Build version visible in footer",
      "Clear Cache & Refresh in settings",
      "Improved PWA update detection",
    ],
    type: 'minor',
    isNew: true
  },
  {
    version: "1.0.0",
    date: "2024-12-01",
    title: "Initial Release",
    highlights: [
      "Daily word puzzles with 5 attempts",
      "Cloud sync for stats across devices",
      "13 tiered achievements (bronze → platinum)",
      "Full puzzle archive with calendar picker",
      "PWA support for offline play",
      "Social sharing with AI-generated captions",
      "Hard mode with letter constraints",
      "Hint system with position reveals",
      "Theme switching (light/dark/system)",
      "Guest mode with optional sign-up",
    ],
    type: 'major'
  }
];

// Check if there's a new announcement to show
export const hasNewAnnouncement = (): boolean => {
  const lastDismissed = localStorage.getItem('wormble-announcement-dismissed');
  const latestNew = CHANGELOG.find(e => e.isNew);
  if (!latestNew) return false;
  return lastDismissed !== latestNew.version;
};

export const dismissAnnouncement = (): void => {
  const latestNew = CHANGELOG.find(e => e.isNew);
  if (latestNew) {
    localStorage.setItem('wormble-announcement-dismissed', latestNew.version);
  }
};

// Get the latest version string
export const LATEST_VERSION = CHANGELOG[0]?.version || "1.0.0";

// Get entries newer than a given version
export function getNewEntries(lastSeenVersion: string): ChangelogEntry[] {
  const lastIndex = CHANGELOG.findIndex(e => e.version === lastSeenVersion);
  if (lastIndex === -1) return CHANGELOG; // Show all if version not found
  return CHANGELOG.slice(0, lastIndex);
}
